import {
  screenSharingControls,
  webPIP
} from "./chunk-DKMPTYNX.mjs";
import {
  payment
} from "./chunk-KI5F6ZOB.mjs";
import {
  displayMode,
  visibility
} from "./chunk-56FLMFMZ.mjs";
import {
  wakeLock
} from "./chunk-O7WRU4N7.mjs";
import {
  webOtp
} from "./chunk-V4LPG4IY.mjs";
import {
  webShare
} from "./chunk-EHD2447D.mjs";
import {
  contentIndexing
} from "./chunk-5PMZLUIF.mjs";
import {
  createFile,
  pickFile,
  pickTextFile,
  readFiles,
  writeFile,
  writeUrlToFile
} from "./chunk-ATDFTNOD.mjs";
import {
  accessFonts
} from "./chunk-D6MF3VJB.mjs";
import {
  fullscreen
} from "./chunk-4BCVN7RN.mjs";
import {
  idleDetection
} from "./chunk-2YUTXSCF.mjs";
import {
  install
} from "./chunk-HM4GVELB.mjs";
import {
  lazyLoad,
  loadBackground,
  loadImage,
  loadOnScroll
} from "./chunk-FSRKNIXR.mjs";
import {
  notification
} from "./chunk-ZYKS5RAZ.mjs";
import {
  check_exports
} from "./chunk-ZNSM6KLG.mjs";
import {
  clearBadge,
  setBadge
} from "./chunk-LFQJARIU.mjs";
import {
  barcodeDetector
} from "./chunk-ICJ2VFAK.mjs";
import {
  compressStream,
  decompressStream
} from "./chunk-3V4QMX44.mjs";
import {
  copyImage,
  copyText,
  readText
} from "./chunk-O4DMFH5W.mjs";
import {
  connectivity
} from "./chunk-46OE5DYA.mjs";
import {
  contacts
} from "./chunk-7KAPG6JK.mjs";
import {
  __export
} from "./chunk-7P6ASYW6.mjs";

// src/pwa/index.ts
var pwa_exports = {};
__export(pwa_exports, {
  accessFonts: () => accessFonts,
  barcodeDetector: () => barcodeDetector,
  clearBadge: () => clearBadge,
  compressStream: () => compressStream,
  connectivity: () => connectivity,
  contacts: () => contacts,
  contentIndexing: () => contentIndexing,
  copyImage: () => copyImage,
  copyText: () => copyText,
  createFile: () => createFile,
  decompressStream: () => decompressStream,
  displayMode: () => displayMode,
  fullscreen: () => fullscreen,
  idleDetection: () => idleDetection,
  install: () => install,
  lazyLoad: () => lazyLoad,
  loadBackground: () => loadBackground,
  loadImage: () => loadImage,
  loadOnScroll: () => loadOnScroll,
  notification: () => notification,
  payment: () => payment,
  pickFile: () => pickFile,
  pickTextFile: () => pickTextFile,
  readFiles: () => readFiles,
  readText: () => readText,
  screenSharingControls: () => screenSharingControls,
  setBadge: () => setBadge,
  visibility: () => visibility,
  wakeLock: () => wakeLock,
  webOtp: () => webOtp,
  webPIP: () => webPIP,
  webShare: () => webShare,
  writeFile: () => writeFile,
  writeUrlToFile: () => writeUrlToFile
});
export {
  accessFonts,
  barcodeDetector,
  check_exports as check,
  clearBadge,
  compressStream,
  connectivity,
  contacts,
  contentIndexing,
  copyImage,
  copyText,
  createFile,
  decompressStream,
  displayMode,
  fullscreen,
  idleDetection,
  install,
  lazyLoad,
  loadBackground,
  loadImage,
  loadOnScroll,
  notification,
  payment,
  pickFile,
  pickTextFile,
  pwa_exports as pwa,
  readFiles,
  readText,
  screenSharingControls,
  setBadge,
  visibility,
  wakeLock,
  webOtp,
  webPIP,
  webShare,
  writeFile,
  writeUrlToFile
};
